import { axiosService } from 'service'
import { salesOrdersEndpoints } from 'service/sources/sales/orders'

const ordersList = (options) => {
  return axiosService.get(salesOrdersEndpoints.LIST + options)
}

const ordersBefore = () => {
  return axiosService.get(salesOrdersEndpoints.BEFORE)
}

const create = (values) => {
  return axiosService.post(salesOrdersEndpoints.CREATE, values)
}

const infoOneOrders = (id) => {
  return axiosService.get(salesOrdersEndpoints.INFO_ONE_ORDERS + '/' + id + '/' + 1)
}

const searchClients = (body) => {
  return axiosService.post(salesOrdersEndpoints.SEARCH_CLIENTS, body)
}

const searchProduct = (body) => {
  return axiosService.post(salesOrdersEndpoints.SEARCH_PRODUCT, body)
}

const addProduct = (values) => {
  return axiosService.post(salesOrdersEndpoints.ADD_PRODUCT, values)
}

const deleteProduct = (body) => {
  return axiosService.post(salesOrdersEndpoints.DELETE_PRODUCT, body)
}

const deleteOrder = (id, empresa) => {
  return axiosService.del(salesOrdersEndpoints.DELETE_ORDER + '/' + id + '/' + empresa)
}

const update = (id, empresa, body) => {
  return axiosService.put(salesOrdersEndpoints.UPDATE + '/' + id + '/' + empresa, body)
}

const addReceiptDetail = (values) => {
  return axiosService.post(salesOrdersEndpoints.ADD_RECEIPT_DETAIL, values)
}

const deleteReceiptItem = (id, empresa, recibo) => {
  return axiosService.del(
    salesOrdersEndpoints.DELETE_RECEIPT_ITEM + '/' + id + '/' + empresa + '/' + recibo
  )
}

const createFactura = (values) => {
  return axiosService.post(salesOrdersEndpoints.CREATE_FACTURA, values)
}

const createReceipt = (values) => {
  return axiosService.post(salesOrdersEndpoints.CREATE_RECEIPT, values)
}

const deleteReceipt = (id, empresa) => {
  return axiosService.del(salesOrdersEndpoints.DELETE_RECEIPT + '/' + id + '/' + empresa)
}

const editProductItem = (body) => {
  return axiosService.put(salesOrdersEndpoints.EDIT_PRODUCT_ITEM, body)
}

const editReceiptItem = (body) => {
  return axiosService.put(salesOrdersEndpoints.EDIT_RECEIPT_ITEM, body)
}

const remito = (body) => {
  return axiosService.post(salesOrdersEndpoints.REMITO, body)
}

const presupuesto = (body) => {
  return axiosService.getPDF(salesOrdersEndpoints.PRESUPUESTO, body)
}

const comprobante = (body) => {
  return axiosService.getPDF(salesOrdersEndpoints.COMPROBANTE, body)
}

const garantia = (body) => {
  return axiosService.getPDF(salesOrdersEndpoints.GARANTIA, body)
}

const clonar = (id, empresa) => {
  return axiosService.post(salesOrdersEndpoints.CLONAR + '/' + id + '/' + empresa)
}

const debitNote = (body) => {
  return axiosService.post(salesOrdersEndpoints.DEBIT_NOTE, body)
}

const creditNote = (body) => {
  return axiosService.post(salesOrdersEndpoints.CREDIT_NOTE, body)
}

const createPaymentOrder = (body) => {
  return axiosService.post(salesOrdersEndpoints.CREATE_PAYMENT_ORDER, body)
}

const addPaymentOrderDetail = (values) => {
  return axiosService.post(salesOrdersEndpoints.ADD_PAYMENT_ORDER_DETAIL, values)
}

const deletePaymentOrder = (id, empresa) => {
  return axiosService.del(salesOrdersEndpoints.DELETE_PAYMENT_ORDER + '/' + id + '/' + empresa)
}

const deletePaymentOrderItem = (id, empresa, orden) => {
  return axiosService.del(
    salesOrdersEndpoints.DELETE_PAYMENT_ORDER_ITEM + '/' + id + '/' + empresa + '/' + orden
  )
}

const editPaymentOrderItem = (body) => {
  return axiosService.put(salesOrdersEndpoints.EDIT_PAYMENT_ORDER_ITEM, body)
}

const searchARCA = (body) => {
  return axiosService.post(salesOrdersEndpoints.SEARCH_ARCA, body)
}

const exportOrders = (body) => {
  return axiosService.post(salesOrdersEndpoints.EXPORT, body)
}

const listProductStock = (body) => {
  return axiosService.post(salesOrdersEndpoints.LISTPRODUCTSTOCK, body)
}

const printReceipt = (body) => {
  return axiosService.getPDF(salesOrdersEndpoints.PRINT_RECEIPT, body)
}

const printShipping = (body) => {
  return axiosService.getPDF(salesOrdersEndpoints.PRINT_SHIPPING, body)
}

export const salesOrders = {
  ordersList,
  ordersBefore,
  create,
  infoOneOrders,
  searchClients,
  searchProduct,
  addProduct,
  deleteProduct,
  deleteOrder,
  update,
  addReceiptDetail,
  deleteReceiptItem,
  createFactura,
  createReceipt,
  deleteReceipt,
  editProductItem,
  editReceiptItem,
  remito,
  presupuesto,
  comprobante,
  garantia,
  clonar,
  debitNote,
  creditNote,
  createPaymentOrder,
  addPaymentOrderDetail,
  deletePaymentOrder,
  deletePaymentOrderItem,
  editPaymentOrderItem,
  searchARCA,
  exportOrders,
  listProductStock,
  printReceipt,
  printShipping,
}
